// extracted by mini-css-extract-plugin
module.exports = {"smallSlider":"SmallSlider_smallSlider__1u62B","content":"SmallSlider_content__3T8pq","buttons":"SmallSlider_buttons__aIx8I","image":"SmallSlider_image__27L8f"};